/**
 * Computes break-aware song numbering for setlist entries.
 *
 * Given an entries array (mix of song entries and note/break items),
 * returns an array of { entry, songNumber } where songNumber is null
 * for notes/breaks. Counter starts at 1, increments for songs, and
 * resets to 1 after a break (isBreak: true). Notes (isBreak: false)
 * do not affect the counter.
 *
 * @param {Array} entries - Array of setlist entries
 * @returns {Array<{ entry: object, songNumber: number|null }>}
 */
function computeNumbering (entries) {
  let counter = 1
  return entries.map(entry => {
    if (entry.type === 'note') {
      if (entry.isBreak) counter = 1
      return { entry, songNumber: null }
    }
    return { entry, songNumber: counter++ }
  })
}

export default computeNumbering
